const checkNext = () => (next) => (action) => {
  // const result = next(action)
  next(action)
  // console.log('action:', action.type);
}

export default checkNext
